
export class UserContext {
  email: string = '';
  name: string = '';
  picture: string = '';
  hasLoggedIn: boolean = false;
}
